import React from "react";

const BusinessInfoSection = ({ onContinue }) => {
  return (
    <div className="max-w-4xl mx-auto px-4">
      <h1 className="text-3xl font-bold mb-6">
        🔥 Join Konnect Business Today!
      </h1>

      <p className="text-2xl mb-8 leading-relaxed">
        Boost your sales, reach more customers, and get instant cash after
        delivery — <span className="font-bold">No Admin Fees!</span>
      </p>

      <div className="mb-8">
        <p className="text-2xl mb-4">
          🍲 <span className="font-bold">Restaurants</span> – Fresh meals,
          same-day/next-day delivery
        </p>
        <p className="text-2xl mb-4">
          🥦 <span className="font-bold">Wholesale</span> – Bulk supply at
          discounted rates
        </p>
        <p className="text-2xl mb-4">
          🛒 <span className="font-bold">Retail</span> – Household items at
          wholesale prices
        </p>
      </div>

      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          ✨ Why Konnect?
        </h2>
        <ul className="text-left text-2xl space-y-2">
          <li>• Free in-app listings & promos</li>
          <li>• Instant & scheduled delivery options</li>
          <li>• Easy digital menus & order tracking</li>
          <li>• Dedicated Support Manager for your business</li>
        </ul>
      </div>

      <p className="text-2xl mb-5 font-bold">
        📑 Documents required within 14 days: CAC Certificate + LGA Food Permit
        (for restaurants)
      </p>

      <p className="text-2xl mb-8">
        👉 Partner with us and grow your business fast!
      </p>

      <div className="flex justify-center">
        <button
          onClick={onContinue}
          className="bg-gray-900 text-white px-8 py-4 rounded-lg font-medium transition text-2xl"
        >
          Get Started
        </button>
      </div>
    </div>
  );
};

export default BusinessInfoSection;
